export enum Side {
    BUY = 'BUY',
    SELL = 'SELL'
}

export const SIDE_LABEL_DICT: Record<Side, string> = {
    [Side.BUY]:  'enums.side.buy',
    [Side.SELL]: 'enums.side.sell'
};

export const SIDE_CLASSNAME_DICT: Record<Side, string> = {
    [Side.BUY]:  '-buy',
    [Side.SELL]: '-sell'
};
